import React from "react";

const SettingsUsers = () => {
	return <div>SettingsUsers</div>;
};

export default SettingsUsers;
